/// <amd-module name="Artifacts/Root/components/GenericModal" />
import { ErrorBannerLoader } from "Artifacts/Root/components/ErrorBannerLoader";
import { ComponentState } from "Artifacts/Root/Constants";
import { registerModal } from "Artifacts/Root/containers/ModalManager";
import { isLoading } from "Artifacts/Root/helpers/ComponentStateHelpers";
import * as Res from "Artifacts/Root/Resources";
import * as React from "react";
import { Dialog } from "VSSUI/Dialog";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

export interface IGenericModalProps {
  title: string;
  className?: string;
  primaryButtonText: string;
  primaryButtonDanger?: boolean;
  warningCardContent?: React.ReactNode;
  onPrimaryClicked: () => void;
  onDismiss: () => void;
  primaryButtonComponentState: ComponentState;
  body?: React.ReactNode;
}

export const GenericModalId = "GenericModal";

const GenericModal: React.FC<IGenericModalProps> = ({
  title,
  className,
  primaryButtonText,
  primaryButtonDanger,
  warningCardContent,
  onPrimaryClicked,
  onDismiss,
  primaryButtonComponentState,
  body,
}) => {
  const prependClassName = (classSuffix: string): string =>
    (className ? className + "-" : "") + classSuffix;

  return (
    <Dialog
      titleProps={{ text: title, className: "generic-artifacts-modal" }}
      lightDismiss={false}
      className={className || "generic-dialog"}
      onDismiss={onDismiss}
      footerButtonProps={[
        {
          className: prependClassName("cancel-button"),
          onClick: onDismiss,
          text: Res.Modal_Cancel,
        },
        {
          className: prependClassName("primary-button"),
          onClick: onPrimaryClicked,
          text: primaryButtonText,
          danger: primaryButtonDanger,
          iconProps: isLoading(primaryButtonComponentState)
            ? {
                render: (className) => <Spinner className={className} size={SpinnerSize.small} />,
              }
            : undefined,
        },
      ]}
    >
      <ErrorBannerLoader state={primaryButtonComponentState} noLoadingSpinner>
        {warningCardContent && (
          <div className="warning-card-container">
            <MessageCard
              className={prependClassName("warning-card")}
              severity={MessageCardSeverity.Warning}
            >
              {warningCardContent}
            </MessageCard>
          </div>
        )}
        {body}
      </ErrorBannerLoader>
    </Dialog>
  );
};

registerModal(GenericModalId, GenericModal);

export { GenericModal };
